// import { LoginForm } from "../../functionalities/login/components/LoginForm";
// import DiagramBasic from "../../components/DiagramBasic";

import { CreditCard } from "../../components/CreditCard";
export const Login = () => {
  // return <LoginForm />;
  return <CreditCard />;
  // return <DiagramBasic />;
};
